import React, { useEffect } from "react";
import block from "bem-cn";
import { useDispatch, useSelector } from "react-redux";
import { actions as notificationsActions } from 'features/notifications/index'

import SVG from "components/SVG";
import Modal from "components/Modal";

import crossSVG from '../img/cross.svg';
import './NotificationModal.scss'

const b = block('notification-modal');

const NotificationModal = ({ onClose, item }) => {
  const locale = useSelector(state => state.locale.locale);
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      if(item.new) dispatch(notificationsActions.setNotificationRead([item.id]));
    }
  }, [dispatch, item.id, item.new]);

  return (
    <Modal onClose={() => onClose(null)}>
      <div className={b()}>
        <div className={b('top')}>
          <div className={b('left')}>
            {item.new && <div className={b('new')}>{locale.new}</div>}
            <div className={b('type')}>{locale.typesOfNotifications[item.tag]}</div>
          </div>
          <div className={b('right')}>
            <div className={b('date')}>{item.date}</div>
            <div className={b('cross-wrapper')} onClick={() => onClose(null)}>
              <SVG className={b('cross').toString()} svgProps={{ svg: crossSVG }} />
            </div>
          </div>
        </div>

        <div className={b('text')}>
          {item.text}
        </div>
      </div>
    </Modal >
  )
};

export default NotificationModal;